import styled from 'styled-components';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;

  align-items: center;
`;

export default Form;
